export default {
  dbb_explore_title: 'Benchmark Explorer',
  dbb_explore_title_explain: '探索行业基准，评估游戏表现并识别潜在的改进点。',
  dbb_explore_metric_all: '全部',
  dbb_explore_metric_kpi: 'KPI',
  dbb_explore_metric_marketing: 'Marketing',
  dbb_explore_metric_technical: 'Technical',
  dbb_explore_metric: '指标',
  dbb_explore_metric_top_10_percent: '前10%',
  dbb_explore_metric_median: '中位数',
  dbb_explore_metric_otdr: 'GTDR',
  dbb_explore_type_all: '全部',
  dbb_explore_type_shooter: '射击',
  dbb_explore_type_soc: '社交',
  dbb_explore_type_rpg: '角色扮演',
  dbb_explore_type_mmo: '多人在线',
  dbb_explore_type_casual: '休闲',
  dbb_explore_recommended_questions: '推荐问题',
  dbb_explore_recommended_genre: '推荐品类',
  dbb_explore_footer_explain: 'Benchmark数据源来自多个真实项目脱敏数据及100+商业采买数据源（如Mscience，VGInsight，GSD，Data.ai）计算得出，如有疑问，请联系sallyxue@tencent.com',
  dbb_explore_metric_filter: '品类筛选',
  dbb_explore_total: '共',
  dbb_explore_records: '条记录',
  dbb_explore_search: '搜索',
  dbb_explore_search_no_match: '没有匹配搜索',
  dbb_explore_search_fail: '搜索失败',
  dbb_explore_search_loading: '加载中...',
  dbb_explore_search_input_error_length: '最大不超过50个字符',
  dbb_explore_search_input_error_special_char: '请输入正确字符，仅支持中文、英文、数字、空格和&、-、（、）、$、%、/符号',
  dbb_explore_search_placeholder: '请输入指标名称（例：留存）',
  dbb_explore_search_no_found: '没有匹配的指标',
  dbb_explore_search_no_found_explain: '抱歉，该指标没有找到对应的行业基准，请尝试输入其他指标',
  dbb_explore_table_detail: '详情',
  dbb_explore_feedback_unlike_placeholder: '请简要描述该功能的不足之处：',
  dbb_explore_feedback_unlike_title: '很遗憾，这个benchmark数据没有帮助到您。请告诉我们具体的原因以便改进。',
  dbb_explore_metrics_table_reset: "重置",
  dbb_explore_pc_console_system: '端游/主机游戏',
  dbb_explore_mobile_system: '手游',
};